<script setup lang="ts">
import { computed } from "vue"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { getAvatarColor, useInitials } from "@/composables/useInitials"
import type { User } from "@/types"

interface Props {
  user: User
  showEmail?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showEmail: false,
})

const { getInitials } = useInitials()

const showAvatar = computed(() => props.user.avatar && props.user.avatar !== "")
const avatarColor = computed(() => getAvatarColor(props.user.name))
</script>

<template>
  <Avatar class="h-8 w-8 overflow-hidden rounded-lg">
    <AvatarImage v-if="showAvatar" :src="user.avatar!" :alt="user.name" />
    <AvatarFallback class="rounded-lg font-semibold" :class="avatarColor" :delay-ms="500">
      {{ getInitials(user.name) }}
    </AvatarFallback>
  </Avatar>

  <div class="grid flex-1 text-left text-sm leading-tight">
    <span class="truncate font-medium">{{ user.name }}</span>
    <span v-if="showEmail" class="text-muted-foreground truncate text-xs">{{
      user.email
    }}</span>
  </div>
</template>
